const global = window

inputs.alias.repeater = 'grid'

inputs.types.grid = function (data, name, niceName, type, input, parent, inputWindow) {
    let gridData = clone(global.iconViewDefaultSettings);

    gridData.default = {
        icon: data.icon,
    };

    for (const key in data.event) {
        gridData.events[key] = function (grid) {
            eval(data.event[key])
        }
    }

    if (data.url) {
        let pf = input.closest('.window, body')

        data.refreshUrl = function() {
            let formData = getFormData(pf)
            const requireInputs = data.url.match(/(\{{2}[A-Za-z_]+\}{2})+/g)
            let url = data.url

            $.each(requireInputs, function () {
                let replaceVar = this
                let replaceInput = this.replace('{{', '').replace('}}', '')
                // let replaceInputEl = pf.find('[data-id="' + replaceInput + '"]')
                // let replaceOut = replaceInputEl.val()
                let replaceOut = formData[replaceInput]

                if (
                    data.map &&
                    data.map[replaceInput] &&
                    data.map[replaceInput][replaceOut]
                ) {
                    replaceOut = data.map[replaceInput][replaceOut]
                }

                url = url.replace(replaceVar, replaceOut)
            })
            return url;
        }

        data.reload = function() {
            let url = data.refreshUrl();
            if (url != data.urlLast) {
                data.urlLast = url;
                input.data('plugin').loadFromUrl(url);
            }
        }

        // apply field action
        const requireInputs = data.url.match(/(\{{2}[A-Za-z_]+\}{2})+/g)
        $.each(requireInputs, function () {
            const replaceInput = this.replace('{{', '').replace('}}', '')

            pf.find('[data-id="' + replaceInput + '"]').keyup(function () {
                if ($('#' + input.attr('id')).length) {
                    // data.reload()
                    debounce(function() {data.reload()}, 200);
                }
            })

            pf.find('[data-id="' + replaceInput + '"]').change(function () {
                if ($('#' + input.attr('id')).length) {
                    data.reload()
                }
            })
        })

        if (requireInputs && requireInputs.length) {
            let url = data.refreshUrl();
            input.attr('href', url).attr('data-url', url)
        }
    }
    else {
        gridData['options'] = {
            template: 'default',
            features: {
                sortable: {
                    field: 'ordre',
                },
            },
            default: data.default ? data.default : 'edit',
            actions: data.actions
                ? data.actions
                : {
                    browse: {
                        label: 'Parcourir',
                        action: 'browse',
                        icon: 'folder',
                    },
                    edit: {
                        label: 'Modifier',
                        title: '%s - Field',
                        action: 'popup',
                        url: 'admin/acf/field/edit/dataId',
                        icon: 'tool-pencil',
                        height: 600,
                        width: 1000,
                    },
                    clone: {
                        label: 'Cloner',
                        action: 'clone',
                        icon: 'copy',
                    },
                    delete: {
                        label: 'Supprimer',
                        action: 'ajaxForm',
                        url: 'admin/acf/field/request/',
                        method: 'DELETE',
                        icon: 'shape-cross',
                        confirm: {
                            title: 'Suppression',
                            text: 'Voulez-vous vraiment supprimer cet élément ?',
                            icon: 'icons/sets/svg/medium.svg#shape-cross',
                        },
                    },
                },
            remap: {
                label: data.map_label
                    ? data.map_label.split('.')
                    : null,
                icon: data.map_icon ? data.map_icon.split('.') : null,
                // "detail": (data.map_detail)?data.map_label.split('.'):null,
            },
        }
        gridData['templates'] = {
            default: {
                view: {
                    default: data.view ? data.view : 'table',
                    mosaic: ['info'],
                    table: [
                        {
                            type: 'icon',
                            label: 'Icône',
                            size: 'small',
                        },
                        {
                            type: 'label',
                            label: 'Nom',
                        },
                        {
                            label: 'Détail',
                            name: 'detail',
                            size: '30',
                            type: 'data',
                        },
                        {
                            name: 'delete',
                            type: 'action',
                        },
                        {
                            name: 'edit',
                            type: 'action',
                        },
                    ],
                },
                buttons: data.buttons ? data.buttons : {},
            },
        }
        gridData['types'] = {
            root: {
                actions: ['edit', 'clone', 'delete'],
                default: 'edit',
            },
        }

        if (data.data) {
            if (data.data.data) gridData.data = data.data.data;
            if (data.data.options) gridData.options = data.data.options;
            if (data.data.templates) gridData.templates = data.data.templates;
        }
    }

    input.not('textarea').iconsView(gridData)
    return data
}
